import {graphql} from 'gatsby';
import Img from 'gatsby-image';
import React, {memo} from 'react';
import {useIntl} from 'react-intl';

import * as option from '../utils/option';
import * as iter from '../utils/iter';

import {intlString} from './intl-string';

// Fragment `GatsbyImageSharpFixed_withWebp` copied from
// https://github.com/gatsbyjs/gatsby/blob/b7e6bb1f730a02ac232dede97d7609e01869f6a7/packages/gatsby-transformer-sharp/src/fragments.js#L136

export const query = graphql`
	fragment RatioImage on Image {
		title {
			...IntlString
		}
		alt {
			...IntlString
		}
		copyright {
			...IntlString
		}
		local {
			childImageSharp {
				ratioImageFluid: fluid(maxWidth: 1280, quality: 80) {
					base64
					aspectRatio
					src
					srcSet
					srcWebp
					srcSetWebp
					sizes
				}
			}
		}
	}
`;

export default memo(
	/**
	 * @param {import("../../tmp/graphql-types").RatioImageFragment & {
	 *   className?: string,
	 * }} props
	 * @returns {React.ReactElement | null} ...
	 */
	function RatioImage({
		title,
		alt,
		local,
		copyright,
		className,
	}) {
		const intl = useIntl();

		const fluid = local?.childImageSharp?.ratioImageFluid;
		if (!fluid) {
			return null;
		}

		const titleIntl = title && intlString(intl, title);
		const altIntl = alt && intlString(intl, alt);
		const copyrightIntl = copyright && intlString(intl, copyright);

		const titleCopyrightIntl = iter.chain(
			iter.once(titleIntl),
			iter.once(option.andThen(copyrightIntl, (c) => `(© ${c})`)),
		)
			.filter(Boolean)
			.toArray()
			.join(' ');

		return (
			<Img
				fluid={fluid}
				alt={altIntl || titleIntl || undefined}
				title={titleCopyrightIntl}
				className={className}
			/>
		);
	}
);
